import React from 'react'

export default function DFToggle({ checked, onChange, disabled }) {
  const trackBg = checked ? 'var(--df-accent, #2f7a3e)' : 'var(--df-bg-2, #ece5d3)'
  const trackBorder = checked ? 'var(--df-accent, #2f7a3e)' : 'var(--df-line-2, #cec3a5)'

  return (
    <button
      role="switch"
      aria-checked={!!checked}
      disabled={disabled}
      onClick={() => !disabled && onChange && onChange(!checked)}
      style={{
        position: 'relative',
        width: 36,
        height: 20,
        borderRadius: 99,
        border: `1px solid ${trackBorder}`,
        background: trackBg,
        cursor: disabled ? 'not-allowed' : 'pointer',
        opacity: disabled ? 0.5 : 1,
        transition: 'background .18s, border-color .18s',
        padding: 0,
        flexShrink: 0,
      }}
    >
      <span
        style={{
          position: 'absolute',
          top: 1,
          left: checked ? 17 : 1,
          width: 16,
          height: 16,
          borderRadius: '50%',
          background: '#fff',
          boxShadow: '0 1px 2px rgba(0,0,0,.18)',
          transition: 'left .18s ease',
        }}
      />
    </button>
  )
}
